import { Divider } from '@dynatrace/strato-components/layouts';

import { DotSeriesTooltipBody } from './DotSeriesTooltipBody.js';
import { DotSeriesTooltipHeader } from './DotSeriesTooltipHeader.js';
import type { DotSeriesWithDatapoints } from '../../../types/xy-chart-internals.js';
import type { DotDatapoint } from '../../../types/xy-chart.js';

export function DotSeriesTooltip({
  datapoint,
  series,
}: {
  datapoint: DotDatapoint;
  series: DotSeriesWithDatapoints;
}) {
  return (
    <>
      <DotSeriesTooltipHeader datapoint={datapoint} series={series} />
      <Divider orientation="horizontal" />
      <DotSeriesTooltipBody datapoint={datapoint} series={series} />
    </>
  );
}
